<template>
  <div class="page">
    <myHeader class="myHeader"></myHeader>
    <div class="block"></div>
    <div class="view">
      <router-view id="view" />
    </div>
  </div>
</template>

<script>
import myHeader from "../components/myHeader.vue";
export default {
  components: {
    myHeader,
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>

<style scoped>
.block {
  height: 80px;
}

.view{
}

</style>